<template>
    <div class="velikost-legende">
        <div>
            <p class="open-sans-20pt" style="text-align: left">
                Legenda brezžično omrežje
            </p>
        </div>
        <table class="legenda">
            <tr>
                <td class="velikost-td glava">
                    <b>
                        Kanal
                    </b>
                </td>
                <td class="vsebina">
                    Izbira kanala Izbirate lahko med različnimi kanali ali nastavite na samodejno izbiro (auto), kar
                    pomeni, da bo modem sam preveril zasedenost kanalov in ga prilagodil na tistega, ki je najmanj
                    zaseden (vsakih 15 minut).
                </td>
            </tr>
            <tr>
                <td class="glava">
                    <b>
                        Ime omrežja
                    </b>
                </td>
                <td class="vsebina">
                    Ime omrežja ali SSID je ime brezžičnega omrežja s katerim se povezujete za uporabo brezžičnega
                    interneta.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    <b>
                        Omogoči brezžično omrežje
                    </b>
                </td>
                <td class="vsebina">
                    Vklop ali izklop delovanja brezžičnega omrežja.
                    <b>
                        Opomba: S to nastavitvijo ne odjavite naročene Wi-Fi storitve.
                    </b>
                    Odjavo lahko uredite
                    <a href="/Naroci/NarociInternet" class="primarna-barva">
                        tukaj
                    </a>.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    <b>
                        Skrij ime omrežja
                    </b>
                </td>
                <td class="vsebina">
                    Označite vidnost brezžičnega omrežja. Skrito omrežje se ne pokazalo na seznam omrežij.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    <b>
                        Varnost
                    </b>
                </td>
                <td class="vsebina">
                    Izbirate lahko med različnimi protokoli za zaščito omrežja. Za zaščiteno z najnovejšim
                    varnostnim protokolom svetujemo WPA2.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    <b>
                        Enkripcija
                    </b>
                </td>
                <td class="vsebina">
                    Šifriranje brezžične povezave.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    <b>
                        Ključ
                    </b>
                </td>
                <td class="vsebina">
                    Geslo za dostop v domače omrežje. Dolgo mora biti med 8 in 32 znaki.
                </td>
            </tr>
            <tr>
              <td class="glava">
                <b>
                  Band Steering
                </b>
              </td>
              <td class="vsebina">
                Vklop funkcije Band Steering združi 2,4 GHz in 5 GHz WiFi omrežji v eno skupno omrežje z istim imenom (SSID) in geslom. Privzeto se uporabi ime omrežja (SSID) iz 2,4 GHz omrežja. Uporabnikova naprava nato samodejno izbere, katero frekvenčno območje (2,4 GHz ali 5 GHz) bo uporabljala, glede na svojo zmogljivost in kakovost signala.
              </td>
            </tr>
        </table>
    </div>
</template>

<script>
  export default {
    name: 'LegendaBrezzicnoOmrezje'
  }
</script>

<style scoped src="../../../../../../static/css/Nastavitve/MreznaOprema/legendaBrezzicnoOmrezje.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/tr069/LegendaBrezzicnoOmrezje.vue